<div id="itemsSection">
    @for (item of invoice.items; track $index) {
        <div class="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-2 mb-3 align-items-end mt-3">
            <div class="col">
                <label class="form-label">QNT:<span class="text-danger">*</span></label>
                <dx-number-box [(value)]="$any(item).quantity" (onValueChanged)="calculateTotalAmount()" [readOnly]="isReadOnly" [min]="1" stylingMode="filled">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Quantity is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-number-box>
            </div>
            <div class="col">
                <label class="form-label">Description:<span class="text-danger">*</span></label>
                <dx-text-box [(value)]="$any(item).description" [readOnly]="isReadOnly" [maxLength]="200" stylingMode="filled">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Description is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col">
                <label class="form-label">Price:<span class="text-danger">*</span></label>
                <dx-number-box [(value)]="$any(item).unitPrice" (onValueChanged)="onUnitPriceChanged($event, item)" [readOnly]="isReadOnly" [min]="negativeAmountsOnly ? undefined : 0" [step]="0.01" stylingMode="filled">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Price is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-number-box>
            </div>
            <div class="col">
                <label class="form-label">Tax:<span class="text-danger">*</span></label>
                <dx-select-box 
                    [dataSource]="taxOptions" 
                    displayExpr="name"
                    valueExpr="rate" 
                    [(value)]="item.taxRate"
                    (onValueChanged)="calculateTotalAmount()"
                    [readOnly]="isReadOnly"
                    stylingMode="filled">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Tax is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="col text-start">
                @if (!isReadOnly) {
                    @if ($index === invoice.items!.length - 1) {
                        <dx-button text="Add" icon="plus" type="default" class="me-2" stylingMode="outlined" (onClick)="addAction()"></dx-button>
                    }
                    @if ($index > 0) {
                        <dx-button text="Remove" icon="trash" type="danger" stylingMode="outlined" (onClick)="removeAction($index)"></dx-button>
                    }
                }
            </div>
        </div>
        <div class="row g-2 mb-3">
            <div class="col-md-12">
                <div class="d-flex flex-wrap align-items-end gap-2">
                    @if (canSeeGlCodes) {
                        @if (editingGlCodeIndexes.has($index)) {
                            <div>
                                <label class="form-label">Site:</label>
                                <dx-select-box [(value)]="item.siteId" [dataSource]="siteDataSource"
                                        displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                        stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly"
                                        (onValueChanged)="onSiteChanged($event, item)" [width]="300">
                                </dx-select-box>
                            </div>
                            <div>
                                <label class="form-label">GL Code:</label>
                                <dx-select-box [(value)]="item.glCodeId" [dataSource]="glCodeDataSourceFor(item)"
                                        displayExpr="shortName" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                        stylingMode="filled" [placeholder]="item.siteId ? 'Select...' : 'Select a Site first'"
                                        [readOnly]="isReadOnly" [disabled]="!item.siteId"
                                        (onSelectionChanged)="onGlCodeChanged($event, item)" [width]="300">
                                </dx-select-box>
                            </div>
                        } @else {
                            <span>{{ item.glCodeName || '-' }}</span>
                        }
                    }
                    @if (!isReadOnly && canEditGlCodes) {
                        <dx-button icon="edit" stylingMode="text" hint="Edit GL Code" (onClick)="toggleGlCodeEdit($index)"></dx-button>
                    }
                </div>
            </div>
        </div>
    }
    <div class="row justify-content-end">
        <div class="col-auto text-end mt-3">
            <div>
                <div class="d-flex justify-content-between mb-2" style="min-width: 200px;">
                    <span>Subtotal:</span>
                    <span>{{ invoice.subTotal | currency: invoice.currency : 'symbol-narrow' : '1.0-2' : 'en-US' }} {{invoice.currency}}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span>Tax:</span>
                    <span>{{ invoice.taxAmount | currency: invoice.currency : 'symbol-narrow' : '1.0-2' : 'en-US' }} {{invoice.currency}}</span>
                </div>
                <hr>
                <div class="d-flex justify-content-between">
                    <strong>Total:</strong>
                    <strong>{{ invoice.totalAmount | currency: invoice.currency : 'symbol-narrow' : '1.0-2' : 'en-US' }} {{invoice.currency}}</strong>
                </div>
                <hr>
                @if(invoice.conversionRate) {
                    <div class="d-flex justify-content-between align-items-center mb-2" style="min-width: 200px;">
                        <div class="d-flex align-items-center">
                            <span>Conversion rate:</span>
                            @if (!isReadOnly) {
                                <dx-button icon="edit" stylingMode="text" hint="Edit conversion rate" class="ms-1" (onClick)="isEditingConversionRate = !isEditingConversionRate"></dx-button>
                            }
                        </div>
                        @if (isEditingConversionRate) {
                            <dx-number-box 
                                [(value)]="invoice.conversionRate" 
                                (onValueChanged)="calculateTotalAmount()" 
                                [min]="0" 
                                [step]="0.01" 
                                [format]="{ type: 'fixedPoint', precision: 6 }" 
                                stylingMode="filled" width="120">
                            </dx-number-box>
                        } @else {
                            <span>{{ invoice.conversionRate | number:'1.0-6' }}</span>
                        }
                    </div>
                    <div class="d-flex justify-content-between mb-2" style="min-width: 200px;">
                        <span>Subtotal:</span>
                        <span>{{ invoice.convertedSubTotal | currency: 'CAD' : 'symbol-narrow' : '1.0-2' : 'en' }} CAD</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <span>Tax:</span>
                        <span>{{ invoice.convertedTaxAmount | currency: 'CAD' : 'symbol-narrow' : '1.0-2' : 'en' }} CAD</span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between">
                        <strong>Total:</strong>
                        <strong>{{ invoice.convertedTotalAmount | currency: 'CAD' : 'symbol-narrow' : '1.0-2' : 'en' }} CAD</strong>
                    </div>
                }
            </div>
        </div>
    </div>
</div>